import { MessageDescriptor } from 'react-intl';
import { FormVmItemConfigType } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../../../infrastructure/utils/form-config.utils';
import { plainText, richText } from '../../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../../modules/formatters';
import { HubModuleLayout } from '../../../../../../../../api/event-hubs.dao';
import {
    MODULE_DISPLAY_BIO_LABEL_TEXT,
    MODULE_DISPLAY_NAME_LABEL_TEXT,
    MODULE_DISPLAY_ORG_LABEL_TEXT,
    MODULE_DISPLAY_PROFILE_IMAGE_LABEL_TEXT,
    MODULE_DISPLAY_TITLE_LABEL_TEXT,
    MODULE_LAYOUT_LIST_OPTION_TEXT,
} from '../../../../../../event-hubs.text';

export const ENABLED = 'enabled';
export const LABEL = 'label';
export const DISPLAY_LABEL = 'displayLabel';
export const DESCRIPTION = 'description';
export const LAYOUT = 'layout';
export const DISPLAY_NAME = 'displayName';
export const DISPLAY_TITLE = 'displayTitle';
export const DISPLAY_ORG = 'displayOrg';
export const DISPLAY_PROFILE_IMAGE = 'displayProfileImage';
export const DISPLAY_BIO = 'displayBio';
export const POSITION_ORDER = 'positionOrder';

const FORM_CONFIG = {
    [ENABLED]: {
        defaultValue: true,
    },
    [LABEL]: {
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [DISPLAY_LABEL]: {
        defaultValue: true,
    },
    [DESCRIPTION]: {
        defaultValue: '',
        validators: [richText.maxLength.long],
        formatters: [trimSpacesLeft],
    },
    [LAYOUT]: {
        defaultValue: HubModuleLayout.LIST,
    },
    [DISPLAY_NAME]: {
        defaultValue: true,
    },
    [DISPLAY_TITLE]: {
        defaultValue: true,
    },
    [DISPLAY_ORG]: {
        defaultValue: true,
    },
    [DISPLAY_PROFILE_IMAGE]: {
        defaultValue: true,
    },
    [DISPLAY_BIO]: {
        defaultValue: true,
    },
    [POSITION_ORDER]: {
        defaultValue: 0,
    },
};

export const SPEAKERS_MODULE_CONFIG: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);

export type DisplayFieldConfig = {
    key: string;
    labelText: MessageDescriptor;
};

export const DISPLAY_FIELD_CONFIGS: DisplayFieldConfig[] = [
    { key: DISPLAY_NAME, labelText: MODULE_DISPLAY_NAME_LABEL_TEXT },
    { key: DISPLAY_TITLE, labelText: MODULE_DISPLAY_TITLE_LABEL_TEXT },
    { key: DISPLAY_ORG, labelText: MODULE_DISPLAY_ORG_LABEL_TEXT },
    { key: DISPLAY_PROFILE_IMAGE, labelText: MODULE_DISPLAY_PROFILE_IMAGE_LABEL_TEXT },
    { key: DISPLAY_BIO, labelText: MODULE_DISPLAY_BIO_LABEL_TEXT },
];

export type LayoutOptionConfig = {
    value: HubModuleLayout.LIST;
    labelText: MessageDescriptor;
};

export const LAYOUT_OPTIONS: LayoutOptionConfig[] = [
    { value: HubModuleLayout.LIST, labelText: MODULE_LAYOUT_LIST_OPTION_TEXT },
];
